export function isExperienceRelatedExperiencesEmpty(props) {
    return !props.edpURL;
}
